/**
 * @typedef {Object} RowMetadata
 * @property {string} rowId - The row ID.
 * @property {string} scheduleId - The ID of the schedule that the row belongs to.
 */

/**
 * @typedef {Object} UndoAction
 * @property {*} value - Value of the cell.
 * @property {string} col - Column name.
 * @property {RowMetadata} row - The row metadata.
 * @property {string} projectId - The ID of the current project.
 * @property {string} action - The action type (e.g. 'SCHEDULE_UPDATE_CELL'. See constants/undoActions)
 *                             Vuex global store dispatch() is called with this action.
 * @property {boolean} allowSpinnerOnUpdate - Whether to show a spinner during updates.
 * @property {boolean} disallowLocalRowUpdate - Whether to block local row updates.
 */

/**
 * Creates an undo action object.
 *
 * @param {Object} params
 * @param {*} params.value - The cell value.
 * @param {string} params.col - The column name.
 * @param {RowMetadata} params.row - The row metadata.
 * @param {string} params.projectId - The project ID.
 * @param {string} [params.action='SCHEDULE_UPDATE_CELL'] - The action type (default: 'SCHEDULE_UPDATE_CELL').
 *                                                          Vuex global store dispatch() is called with this action.
 * @param {boolean} [params.allowSpinnerOnUpdate=true] - Whether to show a spinner (default: true).
 * @param {boolean} [params.disallowLocalRowUpdate=false] - Whether to block local row updates (default: false).
 * @returns {UndoAction}
 */
export function createUndoAction({
  value,
  col,
  row,
  projectId,
  action = 'SCHEDULE_UPDATE_CELL',
  allowSpinnerOnUpdate = true,
  disallowLocalRowUpdate = false,
}) {
  return {
    value,
    col,
    row,
    projectId,
    action,
    allowSpinnerOnUpdate,
    disallowLocalRowUpdate,
  };
}